export const COLORS = {
  OTA: ['#2B3960', '#5E7DD3', '#AEC3FD', '#5C70A9'],
  eiv: ['#86BC25', '#61B5E4', '#26890D', '#007CB0'],
  certificates: ['#86BC25', '#FFCC00', '#cc3300'],
  eInvoicing: ['#86BC25', '#cc3300', '#FFCC00'],
};
